import { useState } from 'react';
import { useXClone } from '@/state/xclone';
import { useSettings } from '@/state/settings';
import { sounds } from '@/audio/synth';
import { cn } from '@/lib/cn';

const MAX_LEN = 280;

export function Compose() {
  const compose = useXClone((s) => s.composePost);
  const handle = useSettings((s) => s.playerHandle);
  const [text, setText] = useState('');

  const len = text.length;
  const canPost = text.trim().length > 0 && len <= MAX_LEN;

  const submit = () => {
    if (!canPost) return;
    compose(text.trim());
    setText('');
    sounds.notifyInfo();
  };

  return (
    <div className="border-b border-[var(--border-subtle)] bg-[var(--bg-surface)] p-3">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
            e.preventDefault();
            submit();
          }
        }}
        placeholder={`what are you doing, @${handle}? · ⌘↵ to post`}
        rows={2}
        maxLength={MAX_LEN + 50}
        className="w-full resize-none rounded border border-[var(--border-subtle)] bg-[var(--bg-deep)] p-2 text-mono-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] outline-none focus:border-[var(--border-strong)]"
      />
      <div className="mt-2 flex items-center justify-between">
        <span className={cn(
          'text-mono-xs tabular-nums',
          len > MAX_LEN ? 'text-[var(--negative)]' : 'text-[var(--text-muted)]',
        )}>
          {len}/{MAX_LEN}
        </span>
        <button
          onClick={submit}
          disabled={!canPost}
          className="rounded-full bg-[var(--accent-primary)] px-4 py-1 text-mono-sm font-bold text-black disabled:opacity-30"
        >
          Post
        </button>
      </div>
    </div>
  );
}
